import React, { useState } from "react";
import Footer from "../../components/footer";
import { Link } from "react-router-dom";
import img1 from "../../../src/assets/images/khojgraphics/USP 1.png";
import img2 from "../../../src/assets/images/khojgraphics/USP 2.png";
import img3 from "../../../src/assets/images/khojgraphics/USP 3.png";
import img4 from "../../../src/assets/images/khojgraphics/USP 4.png";


Couter.propTypes = {};

function Couter(props) {
	const [viewPortEntered, setViewPortEntered] = useState(false);

	const onVWEnter = () => {
		setViewPortEntered(true);
	};
	const { className } = props;
	return (
		<div className={`align-item-center ${className}`}>

			<section className="wd-iconbox style-3 inner-iconbox-section user-works-style p-0 ">
				<div className="container">
					<div className="title-iconbox style-3 stc">
						<h1>Why Choose <span className="khoj-text-color">KHOJ</span> ?</h1>
						{/* <p>
							Your Dream, Our Priority
						</p> */}
					</div>
					<div className="row align-items-stretch group-category-job">

						<div className="tf-iconbox job-category-data style-3 col-sm-12 col-lg-3  stc2 p-2 col-md-6 text-center  mb-2 whychoose-tf-iconbox " >
							<div className="box-header">
								<div className="img1">
									<img src={img1} alt="img" className="mb-1" />
								</div>
							</div>
							<div className="box-content">
								<h5 className="box-title mt-3">
									Your Career Ally, Every Step of the Way
								</h5>
								<p>
									Khoj serves as a crucial link between education and employment, empowering professionals with 0 to 9 years of experience to navigate the complexities of early career development. From campus life to career advancement, it provides the tools, resources, and tailored opportunities needed to transition smoothly from entry-level to mid-level roles, offering expert guidance and support every step of the way.
								</p>
							</div>
						</div>
						<div className="tf-iconbox job-category-data style-3 col-sm-12 col-lg-3  stc2 p-2 col-md-6 text-center  mb-2 whychoose-tf-iconbox" >
							<div className="box-header">
								<div className="img1">
									<img src={img2} alt="img" className="mb-1" />
								</div>
							</div>
							<div className="box-content">
								<h5 className="box-title mt-3">
									From Campus Walls to Career Horizons
								</h5>
								<p>
									Khoj recognizes that a graduate’s journey transcends the boundaries of campus life. Its career services continue well after graduation, supporting students as they transition into the workforce and advance in their careers. With a proven track record of placing over 2,000 students annually, Khoj not only drives exceptional placement outcomes but also ensures that graduates are not simply employed, but strategically positioned for sustained, long-term career growth.

								</p>
							</div>
						</div>
						<div className="tf-iconbox job-category-data style-3 col-sm-12 col-lg-3  stc2 p-2 col-md-6 text-center  mb-2 whychoose-tf-iconbox " >
							<div className="box-header">
								<div className="img1">
									<img src={img3} alt="img" className="mb-1" />
								</div>
							</div>
							<div className="box-content">
								<h5 className="box-title mt-3">
									Accelerating Talent Discovery for Corporates

								</h5>
								<p>
									Khoj delivers a pre-screened, qualified talent pool to organizations, enhancing selection success rates while optimizing time, effort, and cost. It is designed to streamline hiring processes, enabling corporates to focus on growth and innovation with the right talent on Board.

								</p>
							</div>
						</div>
						<div className="tf-iconbox job-category-data style-3 col-sm-12 col-lg-3  stc2 p-2 col-md-6 text-center  mb-2 whychoose-tf-iconbox" >
							<div className="box-header">
								<div className="img1">
									<img src={img4} alt="img" className="mb-1" />
								</div>
							</div>
							<div className="box-content">
								<h5 className="box-title mt-3">
									Democratizing Opportunities, Empowering Youth

								</h5>
								<p>
									Khoj redefines access to opportunities by bridging the information gap between talent and potential careers. It strives to create a level playing field, ensuring that young professionals have equal access to resources, empowering them to shape a brighter and more inclusive future.

								</p>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}

export default Couter;
